import BaseModel from '@/orm/models/BaseModel';

export default class BillingPayment extends BaseModel {
  static entity = 'billingPayments';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      status: this.string(null),
      rawStatus: this.string(null),
      type: this.string(null),
      itemType: this.string(null),
      createdAt: this.string(null),
      amount: this.attr(null),
      currency: this.string(),
      data: this.attr(null),
      plan: this.attr(null),
      price: this.attr(null),
      period: this.attr(null),
    };
  }

  static state() {
    return {
      total: 0,
      perPage: 15,
      currentPage: 0,
      lastPage: 0,
    };
  }

  static async index(params) {
    const request = await this.api().fetchAll(params);

    const { data, meta } = request.response.data;

    const entities = await this.insert({ data });

    await this.commit((state) => {
      state.total = meta.total;
      state.perPage = meta.per_page;
      state.currentPage = meta.current_page;
      state.lastPage = meta.last_page;
    });

    return entities;
  }

  static getMetaData() {
    const {
      total, perPage, currentPage, lastPage,
    } = this.store().state.entities[this.entity];
    return {
      total, perPage, currentPage, lastPage,
    };
  }

  static apiConfig = {
    actions: {
      fetchAll(params) {
        const { perPageValue, pageValue } = params;
        return this.get('billing/payments', {
          params: {
            perPage: perPageValue ?? 15,
            page: pageValue ?? 0,
          },
        });
      },
    },
  }
}
